export default "__VITE_ASSET__bdb084b4__"